export enum InventoryPageEnum {
  ITEM = "Item List",
  LOCATION = "Location",
  PACKAGING = "Packaging type",
  PREPARATION = "Method of preparation",
  EXCEPTION = "Exception codes",
  EXCEPTION_LOCATION = "Exception location code",
  MODE = "Mode type",
  SPECIAL_INSTRUCTIONS = "Item instructions",
  DESTINATION = "Item destination",
}
